<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des gabarits de formulaire"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :searchArgs="[
                            {
                                key: 'instance',
                                value: Mantle.FormTemplate.instanceForm
                            }
                        ]"
                :edit="dataEdit"
                :duplicate="dataDuplicate"
                root="/form-template/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/form-template"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du gabarit')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce gabarit?')"></ModalTrash>
        <ModalDuplicate
                ref="duplicate"
                root="/form-template/duplicate"
                @onDuplicateSuccess="onDuplicateSuccess"
                :caption="Core.Definition.getDefinition('Duplication du modèle')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir dupliquer ce modèle?')"></ModalDuplicate>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    import ModalTrash from '../../components/ModalTrash'
    import ModalDuplicate from '../../components/ModalDuplicate'
    export default {
        name: 'FormTemplateList',
        components: {
            DynamicCardList,
            ModalTrash,
            ModalDuplicate
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Titre'),
                        key: 'title',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        type: 'date',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'title'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'title',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                },
                dataDuplicate: {
                    show: true,
                    text: '<button class="btn btn-sm btn-light"><i class="fa fa-copy"></i></button>',
                    onClick:  this.clickDuplicate
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/formulaire/gabarits/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            clickDuplicate(value, cell, row) {
                this.$refs.duplicate.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            },
            onDuplicateSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
